// Dark mode toggle per StyleGuide §2.4 — respect system preference, allow manual override.

type Theme = 'light' | 'dark';

export function initTheme(): void {
  const saved = (localStorage.getItem('theme') as Theme | null) ?? null;
  const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const theme: Theme = saved ?? (systemDark ? 'dark' : 'light');
  document.documentElement.setAttribute('data-theme', theme);
}

export function toggleTheme(): void {
  const current = document.documentElement.getAttribute('data-theme') as Theme | null;
  const next: Theme = current === 'dark' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', next);
  localStorage.setItem('theme', next);
}
